/** Notices raised outside components: agent runs, updates, connections, privacy and desktop availability. */
export default {
  cliUpdateTitle: "CLI update available",
  cliUpdateDescription: "Update {tools} to refresh model availability.",
  toolCallRejected: "Tool call rejected",
  agentStopped: "Agent stopped",
  taskPaused: {
    one: "{task} paused after {count} autonomous run",
    other: "{task} paused after {count} autonomous runs",
  },
  taskPausedDescription: "Reply on the task or move it to continue.",
  heartbeatPausedTitle: "{agent} heartbeat paused",
  heartbeatPausedDescription: {
    one: "Paused after {count} run in 24 hours.",
    other: "Paused after {count} runs in 24 hours.",
  },
  agent: "Agent",
  resume: "Resume",
  projectConnectionsLoadFailed: "Couldn’t load project connections",
  projectFramesLoadFailed: "Couldn’t load project frames",

  statusActive: "Connected",
  statusInitiated: "Connecting…",
  statusExpired: "Expired — Reconnect",
  statusFailed: "Connection failed",
  statusInactive: "Inactive",

  desktopMacAndWindows:
    "Denker currently supports Mac and Windows. Linux is coming.",
  desktopMacOnly: "Denker is currently available for macOS only.",
  errorReportsFailed:
    "Couldn’t start webview error reports. Error reports remain off. Retry sync to try again.",
  privacySaveFailed:
    "Couldn’t save this choice. Optional telemetry remains off.",
  privacySyncFailed:
    "Couldn’t sync your privacy choice. Analytics on this device remains off. Your account choice may not be updated; retry sync.",

  weatherIn: "Weather in {place}",
  appsMore: {
    one: "{first} and {count} more app: {rest}",
    other: "{first} and {count} more apps: {rest}",
  },
  openInApp: "Open in {app}",

  pinnedFull: "Pinned is full. Unpin something first.",
  pinFailed: "Could not pin",
  unpinFailed: "Could not unpin",
} as const;
